/**
 * city/textures/textures-street.js
 * Texture hạ tầng đường phố đô thị Việt Nam (nhựa đường, vỉa hè terrazzo, bó vỉa, hố ga, nắp cống)
 */

import { createRng, shade } from '../builder-core.js';

class MethodsHolder {
  // Mặt đường nhựa: đá dăm lấm tấm, mảng vá, vết nứt
  getAsphaltTexture() {
    return this._tex('asphalt', 512, 512, (ctx, w, h) => {
      const rnd = createRng(2024);
      ctx.fillStyle = '#3f3f46';
      ctx.fillRect(0, 0, w, h);
      for (let i = 0; i < 9000; i++) {
        const s = 1 + rnd() * 2;
        const v = rnd();
        ctx.fillStyle = v < 0.5 ? `rgba(20,20,22,${0.3 + rnd() * 0.3})` : `rgba(160,160,165,${0.15 + rnd() * 0.2})`;
        ctx.fillRect(rnd() * w, rnd() * h, s, s);
      }
      for (let i = 0; i < 4; i++) {
        ctx.fillStyle = `rgba(24,24,27,${0.25 + rnd() * 0.2})`;
        ctx.fillRect(rnd() * w, rnd() * h, 40 + rnd() * 90, 30 + rnd() * 60);
      }
      ctx.strokeStyle = 'rgba(15,15,17,0.6)';
      ctx.lineWidth = 1.5;
      for (let i = 0; i < 5; i++) {
        let x = rnd() * w,
          y = rnd() * h;
        ctx.beginPath();
        ctx.moveTo(x, y);
        for (let k = 0; k < 6; k++) {
          x += (rnd() - 0.5) * 50;
          y += (rnd() - 0.5) * 50;
          ctx.lineTo(x, y);
        }
        ctx.stroke();
      }
    });
  }

  // Gạch lát vỉa hè terrazzo 40x40cm (texture = 2m x 2m)
  getSidewalkTexture() {
    return this._tex('sidewalk', 256, 256, (ctx, w, h) => {
      const rnd = createRng(77);
      ctx.fillStyle = '#8a8076';
      ctx.fillRect(0, 0, w, h);
      const n = 5,
        s = w / n;
      const tones = ['#b8aa9c', '#bfa896', '#b3a699', '#bba998'];
      for (let i = 0; i < n; i++) {
        for (let j = 0; j < n; j++) {
          const base = tones[Math.floor(rnd() * tones.length)];
          ctx.fillStyle = rnd() < 0.06 ? shade(base, -0.12) : base;
          ctx.fillRect(i * s + 1.5, j * s + 1.5, s - 3, s - 3);
          for (let k = 0; k < 40; k++) {
            ctx.fillStyle = rnd() < 0.5 ? 'rgba(255,255,255,0.22)' : 'rgba(60,40,30,0.18)';
            ctx.fillRect(i * s + rnd() * s, j * s + rnd() * s, 1.5, 1.5);
          }
        }
      }
    });
  }

  // Bó vỉa đá granite xám, mạch nối mỗi 1m (texture = 2m)
  getCurbTexture() {
    return this._tex('curb', 256, 64, (ctx, w, h) => {
      const rnd = createRng(5);
      ctx.fillStyle = '#a1a1aa';
      ctx.fillRect(0, 0, w, h);
      for (let i = 0; i < 1200; i++) {
        ctx.fillStyle = rnd() < 0.5 ? 'rgba(255,255,255,0.25)' : 'rgba(30,30,30,0.25)';
        ctx.fillRect(rnd() * w, rnd() * h, 1.5, 1.5);
      }
      ctx.fillStyle = '#52525b';
      ctx.fillRect(0, 0, 2, h);
      ctx.fillRect(w / 2, 0, 2, h);
    });
  }

  getGrateTexture() {
    return this._tex('grate', 128, 64, (ctx, w, h) => {
      ctx.fillStyle = '#3f3f46';
      ctx.fillRect(0, 0, w, h);
      ctx.fillStyle = '#0a0a0a';
      for (let x = 10; x < w - 8; x += 12) ctx.fillRect(x, 10, 6, h - 20);
    });
  }

  getManholeTexture() {
    return this._tex('manhole', 128, 128, (ctx, w, h) => {
      ctx.fillStyle = '#44403c';
      ctx.fillRect(0, 0, w, h);
      ctx.strokeStyle = '#1c1917';
      ctx.lineWidth = 3;
      for (let r = 14; r < 64; r += 12) {
        ctx.beginPath();
        ctx.arc(w / 2, h / 2, r, 0, Math.PI * 2);
        ctx.stroke();
      }
      ctx.beginPath();
      ctx.moveTo(0, h / 2);
      ctx.lineTo(w, h / 2);
      ctx.moveTo(w / 2, 0);
      ctx.lineTo(w / 2, h);
      ctx.stroke();
    });
  }
}

export function registerTextureStreetMethods(proto) {
  Object.getOwnPropertyNames(MethodsHolder.prototype).forEach((name) => {
    if (name !== 'constructor') {
      proto[name] = MethodsHolder.prototype[name];
    }
  });
}
